<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Joe’s Toe Gizmo®</h2>

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml">
            <photo
              @setFeature="setFeatureImg"
              src="contrology_joe-toe-gizmo1@1x.jpg"
              src2="contrology_joe-toe-gizmo1@2x.jpg"
              alt="Photo of Joe's Toe Gizmo"
              caption="Light Spring"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_joe-toe-gizmo2@1x.jpg"
              src2="contrology_joe-toe-gizmo2@2x.jpg"
              alt="Photo of Joe's Toe Gizmo"
              caption="Heavy Spring"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_joe-toe-gizmo3@1x.jpg"
              src2="contrology_joe-toe-gizmo3@2x.jpg"
              alt="Photo of Joe's Toe Gizmo"
              caption=""
            />
          </photo-grid>

          <div class="content-wrapper">
            <section class="intro">
              <h2>Joe’s Toe Gizmo®</h2>
              <p>
                Traditional Pilates equipment, with improvements you’ll love! Designed in collaboration with leading Pilates educators, our Joe’s Toe Gizmo® improves bunions, corrects toe misalignments, strengthens feet, and improves balance and gait. And we’ve made it better than others on the market – it won’t come apart, the metal parts are non-corrosive, and the spring will not wear out. Comes in two resistances: heavy spring (with black loops) or light spring (with red loops). Or, buy the discounted set of two, which includes one of each.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>
                  <b>30 day money-back guarantee.</b> If, for any reason, you are not 100% satisfied with the Joe’s Toe Gizmo, simply return it to us within 30 days for a refund (less freight). Guarantee applies to U.S. domestic customers only.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              :fsahsa="true"
            />

            <section class="links">
              <icon-link
                url="warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >90-Day Limited Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
            </section>

          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
// import CtaProdButton from "@/components/CtaProdButton.vue";
// import TertiaryButton from "@/components/TertiaryButton.vue";

export default {
  name: "toegizmo",

  metaInfo: {
    title: "Joe's Toe Gizmo",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Traditional Pilates equipment, with improvements you’ll love! Designed in collaboration with leading Pilates educators, our Joe’s Toe Gizmo® improves bunions, corrects toe misalignments, strengthens feet, and improves balance and gait."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    // CtaProdButton,
    // TertiaryButton
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      show: false, // Intro content
      product: {
        label: "Select Resistance",
        value: "",
        key: "name"
      },
      option1: {},
      option2: {},
      products: [
        // Product options
        {
          prodid: 41119048401089,
          partnumber: "720-046",
          price: 80,
          name: "Light Spring",
          available: true
        },
        {
          prodid: 41119048433857,
          partnumber: "720-041",
          price: 80,
          name: "Heavy Spring",
          available: true
        },
        {
          prodid: 41119048466625,
          partnumber: "914-000",
          price: 145,
          name: "Set of 2 (Light & Heavy)",
          available: true
        },
      ]
    };
  },
  
  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.col-flex {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
}

.col-flex p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
  margin-bottom: 20px;
}

.col-flex img {
  width: 100%;
  max-width: 320px;
  max-height: 220px;
}

.resistance-image {
  width: 100%;
  max-width: 495px;
  order: 4;
}

@media only screen and (min-width: 600px) {
  .col-flex {
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
  }

  .col-flex p {
    padding-right: 20px;
    max-width: 470px;
    margin: 0;
  }

  .resistance-image {
    max-width: 100%;
  }
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .resistance-image {
    max-width: 530px;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 20px 0 10px;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  .col-flex {
    flex-flow: column nowrap;
    order: 5;
  }

  .col-flex p {
    margin-bottom: 30px;
  }

  .icon-link {
    margin: 0;
  }

  .more {
    order: 5;
    margin-top: 20px;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 550px auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 2;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 2 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .col-flex {
    grid-column: 2 / span 1;
    grid-row: 3 / span 1;
    align-items: flex-start;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  .icon-link {
    margin: 1px;
  }
}
</style>
